/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CurrencyEnumDto {
  DKK = 'DKK',
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
}
